module.exports = __webpack_public_path__ + "0da322fa239b77209f7328bb0f3d7d01.MP3";